import { BaseModel, enumField, ModelInstance, DateTimeField, ToBackHook, ToFrontHook } from './util';
import { Team } from './team';
import { TeamEventTypeLocalization } from '../localization/team-event-type';
import { TeamEventTypes } from './team-event-type';

@ModelInstance({
  mappingFields: {
    id: 'id',
    team_id: 'teamId',
    team: 'team',
    event_type: 'eventType',
    event_custom_name: 'eventCustomName',
    description: 'description',
    datetime: 'datetime',
    location: 'location',
  },
  relation: {
    eventType: enumField(TeamEventTypes),
    team: Team,
    datetime: DateTimeField,
  }
})
export class TeamEvent extends BaseModel {
  id: number;
  teamId: number;
  team: Team;
  eventType: TeamEventTypes;
  eventCustomName: string;
  description: string;
  datetime: Date;
  location: string;

  get name(): string {
    if (this.eventType === TeamEventTypes.other) {
      return this.eventCustomName;
    }
    return TeamEventTypeLocalization[this.eventType];
  }

  get isClosed(): boolean {
    return this.datetime.getTime() < new Date().getTime();
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
